import React from 'react';
import { Link } from 'react-router-dom';
import './CompanyHomePage.scss';

import swipingVideo from 'images/swiping-hero-animation.mp4';
import pokitoVideo from 'images/pokito-website.mp4';
import bittyVideo from 'images/bitty-city-animation.mp4';

const CompanyHomePage = () => {
    return (
        <div className="company-home">
            <div className="company-home__header">
                <h1 className="company-home__title">SideJawn Inc.</h1>
                <p className="company-home__subtitle">Building products that solve real problems for real people</p>
            </div>
            
            <div className="company-home__buttons">
                <a 
                    href="https://pokito.shop" 
                    className="company-home__button company-home__button--pokito"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="company-home__badge company-home__badge--live">
                        <span className="company-home__badge-dot"></span>
                        Live now
                    </span>
                    <video 
                        className="company-home__button-video" 
                        autoPlay 
                        loop 
                        muted 
                        playsInline
                    >
                        <source src={pokitoVideo} type="video/mp4" />
                    </video>
                    <div className="company-home__button-content">
                        <span className="company-home__button-name">Pokito</span>
                        <span className="company-home__button-tagline">Enforcing daily routines with physical checkpoints</span>
                    </div>
                </a>

                <a
                    href="https://bitty.city"
                    className="company-home__button company-home__button--bitty"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="company-home__badge company-home__badge--coming-soon">
                        Coming Soon
                    </span>
                    <video
                        className="company-home__button-video"
                        autoPlay
                        loop
                        muted
                        playsInline
                    >
                        <source src={bittyVideo} type="video/mp4" />
                    </video>
                    <div className="company-home__button-content">
                        <span className="company-home__button-name">Bitty.City</span>
                        <span className="company-home__button-tagline">Build cities & consistent habits with friends.</span>
                    </div>
                </a>

                <Link
                    to="/product"
                    className="company-home__button company-home__button--sidejawn"
                >
                    <span className="company-home__badge">Sunsetted</span>
                    <video 
                        className="company-home__button-video" 
                        autoPlay 
                        loop 
                        muted 
                        playsInline
                    >
                        <source src={swipingVideo} type="video/mp4" />
                    </video>
                    <div className="company-home__button-content">
                        <span className="company-home__button-name">SideJawn</span>
                        <span className="company-home__button-tagline">Connecting like-minded people to work on side projects together</span>
                    </div>
                </Link>
            </div>
            
            <footer className="company-home__footer">
                <p>&copy; 2023 SideJawn Inc. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default CompanyHomePage;
